module.exports = __webpack_public_path__ + "static/media/frutiger-65bold.65827ca7.woff";